<script lang="ts">
  import type UserDetails from "../../Logic/Osm/OsmConnection"
  import { Store, UIEventSource } from "../../Logic/UIEventSource"
  import UserCircle from "@rgossiaux/svelte-heroicons/solid/UserCircle"
  import { IsOnline } from "../../Logic/Web/IsOnline"

  /**
   * USer icon, if available
   */
  export let userdetails: Store<UserDetails>

  let loaded = new UIEventSource(false)
  let isOnline = IsOnline.isOnline
</script>

{#if !$userdetails.img || !($loaded || $isOnline)}
  <UserCircle class="h-14 w-14" color="gray" />
{:else}
  <img
    alt="avatar"
    src={$userdetails.img}
    class="h-12 w-12 rounded-full"
    on:load={() => {
      loaded.set(true)
    }}
  />
{/if}
